const familia = {
  createFamilia: 'familia',
  createInscripcionManual: 'familia/{{uuid_familia}}/manual',
  deleteFamiliaMiembro: 'familia/{{uuid_familia}}/quitar-integrantes',
  readFamilias: 'familias/{{uuid_proyecto}}',
  readFamiliaMiembros: 'familia/{{uuid_familia}}/integrantes',
  readFamiliaNombres: 'familias/{{uuid_proyecto}}/listar-nombres',
  readFamiliasExportar: 'familias/{{uuid_proyecto}}/exportar',
  readInscripcionesSinFamilia: 'inscripciones-sin-familia/{{uuid_proyecto}}',
  updateFamilia: 'familia/{{uuid_familia}}',
  updateFamiliaEstado: 'familia/{{uuid_familia}}/estado',
  updateFamiliaLider: 'familia/{{uuid_familia}}/lider'
}

export default familia
